module.exports = __webpack_public_path__ + "static/media/KMH_5231.67a901a8.jpg";